import { Component, inject } from "@angular/core";
import { WidgetFilterKey } from "@app/dashboard/shared/models/WidgetFilterKey";
import { Pages } from "@constants/pages/Pages";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/dashboard/i18n/scope";
import { BaseChartWidget } from "../BaseChartWidget";
import { ReportPowerbiComponent } from "@app/report/report-powerbi/report-powerbi.component";

@Component({
    selector: "embedded-report-widget",
    templateUrl: "./embedded-report-widget.component.html",
    styleUrls: ["./embedded-report-widget.component.scss"],
    imports: [TranslatePipe, ReportPowerbiComponent],
    viewProviders: [provideTranslationScope(scope)]
})
export class EmbeddedReportWidgetComponent extends BaseChartWidget {
    invalidConfig = false;

    waitInput = true;
    reportID: string;

    private pages = inject(Pages);

    public openReport() {
        this.onGlobalOpenClick();
    }

    async load() {
        this.setReportID();
        this.setWaitCheck();
        super.load();
    }

    private setReportID() {
        const reportID = this.getFilter(WidgetFilterKey.Insights.ReportToEmbed);

        this.invalidConfig = !reportID || reportID <= 0;
        this.reportID = reportID;
        this.config.showLoader = false;
    }

    private setWaitCheck() {
        const skipCheck = this.getFilter(WidgetFilterKey.Insights.ReportSkipLoadCheck);
        this.waitInput = !skipCheck;
    }

    protected onFilterChange() {
        super.onFilterChange();
        this.setReportID();
    }

    protected onResize() {}

    protected async onGlobalOpenClick() {
        if (this.reportID) {
            this._tabService.generateTab(this.pages.PowerBIReport, this.reportID);
        }
    }
}
